import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@scentregroup/ui'
import { MarketplaceContainer } from '../marketplace-container'

const PageHeading = ({ title }) => (
  <MarketplaceContainer>
    <Heading type="large">{title}</Heading>
  </MarketplaceContainer>
)

PageHeading.propTypes = {
  title: PropTypes.string.isRequired,
}

export default PageHeading
